import {
  ApplicationRef,
  Component, ComponentFactoryResolver, ContentChild,
  ContentChildren,
  EventEmitter, Injector, Input,
  Output,
  QueryList, ViewChild
} from '@angular/core';
import { PickerChoiceDirective } from './directives/picker-choice.directive';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PickerDialogComponent } from './picker-dialog/picker-dialog.component';
import { CdkPortal, DomPortalOutlet } from '@angular/cdk/portal';
import { PickerButtonDirective } from './directives/picker-button.directive';

@Component({
  selector: 'app-multi-images-picker',
  templateUrl: './multi-images-picker.component.html',
  styleUrls: [ './multi-images-picker.component.sass' ]
})
export class MultiImagesPickerComponent<T> {
  get value(): T {
    return this._value;
  }

  @Input() rowHeight = '4:3';

  @Input()
  set value(value: T) {
    if (value !== this._value) {
      this.valueChange.emit(value);
    }
    this._value = value;
    this.closeDialog();
  }

  @Output() valueChange: EventEmitter<T> = new EventEmitter<T>();
  @Output() open: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ContentChild(PickerButtonDirective) openButton: PickerButtonDirective<T>;
  @ContentChildren(PickerChoiceDirective) choices: QueryList<PickerChoiceDirective<T>>;
  @ViewChild(CdkPortal)
  private portal: CdkPortal;
  private _value: T;
  private host: DomPortalOutlet;
  private dialogRef: MatDialogRef<PickerDialogComponent<unknown>, any>;

  constructor(public dialog: MatDialog,
    private cfr: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector) {
  }


  onClickCurrentValue() {
    this.openDialog();
    this.projectContentIntoDialog();
  }

  private openDialog() {
    this.open.emit(true);
    this.dialogRef = this.dialog.open(PickerDialogComponent, {
      height: '600px',
      width: '600px',
    });
  }

  private closeDialog() {
    if (!this.dialogRef) {
      return;
    }
    this.dialogRef.close();
  }

  private projectContentIntoDialog() {
    this.host = new DomPortalOutlet(document.querySelector('#picker-dialog-choices'),
      this.cfr, this.appRef, this.injector);
    this.host.attach(this.portal);
  }


}
